/* Audit 2026-09-16 (A5-03): "16 x 25 x 1", "16×25×1" and "16x25x1"" are the
   same size, but Shopify search treats the spaced form as three tokens and
   returned 1,000 Exact cut-to-size results led by $184 fiberglass instead of
   the size collection. Normalise size-shaped queries to the catalogue's
   compact form before they leave the browser. Non-size queries are untouched.

   2026-09-18: quotes are the shopper's call. Shopify phrase-matches a quoted
   size ("16x25x1" = the 36 filters in that size; bare 16x25x1 = 380 near
   misses), and the first cut of this normaliser read a trailing " as an inch
   mark and ate the closing quote people typed by hand — turning their exact
   search back into a fuzzy one. A quote that closes an open one is kept;
   nothing is added (Beau: don't force quotes). rtf-search-tip teaches it. */
function rtfNormalizeSizeQuery(q) {
  if (!q) return q;
  const num = '(\\d+(?:[.,]\\d+)?(?:\\s*-?\\s*\\d+\\/\\d+)?)';
  const inch = '(?:\\s*["\u2033\u201d])?';   // optional inch mark; only eats whitespace when a mark follows
  const re = new RegExp(num + inch + '\\s*[x\u00d7X*]\\s*' + num + inch + '(?:\\s*[x\u00d7X*]\\s*' + num + inch + ')?');
  return q.replace(re, (m, a, b, c, offset, str) => {
    // "15 1/2" is a mixed fraction: join with a hyphen, never squash to "151/2" (final F5)
    const clean = (v) => v.replace(/(\d)\s+(\d+\/\d+)/g, '$1-$2').replace(/\s+/g, '').replace(',', '.');
    const size = c ? `${clean(a)}x${clean(b)}x${clean(c)}` : `${clean(a)}x${clean(b)}`;
    // An odd number of quotes before the size means one is open; if the inch
    // regex just swallowed the " that closes it, give it back.
    const open = ((str.slice(0, offset).match(/"/g) || []).length % 2) === 1;
    const ate = m.endsWith('"') && str[offset + m.length] !== '"';
    return open && ate ? size + '"' : size;
  }).replace(/\s{2,}/g, ' ').trim();
}
window.rtfNormalizeSizeQuery = rtfNormalizeSizeQuery;

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      // Rewrite the value on the way out so the results URL carries the compact form.
      this.input.form.addEventListener('submit', () => {
        const n = rtfNormalizeSizeQuery(this.input.value);
        if (n && n !== this.input.value) this.input.value = n;
      });

      if ((this.input.dataset.secondPlaceholder || this.input.dataset.thirdPlaceholder || this.input.dataset.fourthPlaceholder)
        && (this.input.dataset.animatedPlaceholderMob === 'true' || !window.matchMedia('(max-width: 749.98px)').matches)) {
        this.typewriter();
      }
    }
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event?.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
    }
  }

  /**
   * Cycles through placeholder strings, simulating typing and deleting.
   */
  async typewriter() {
    const typingSpeed = 40;

    // Collect available placeholder strings
    const placeholders = [
      this.input.placeholder,
      this.input.dataset.secondPlaceholder,
      this.input.dataset.thirdPlaceholder,
      this.input.dataset.fourthPlaceholder,
    ].filter(Boolean);

    if (placeholders.length === 0) return;

    // Small delay helper
    const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const typeText = async (target) => {
      let current = this.input.getAttribute('placeholder') || '';
      // Avoid retyping overlapping prefix
      let remaining = (current.length >= 3 && target.startsWith(current))
        ? target.slice(current.length)
        : target;

      for (const char of remaining) {
        current += char;
        this.input.setAttribute('placeholder', current);
        await wait(typingSpeed);
      }
    };

    const deleteText = async (nextTarget) => {
      let current = this.input.getAttribute('placeholder') || '';

      while (
        current.length > 0 &&
        !(current.length >= 3 && nextTarget.startsWith(current))
        ) {
        current = current.slice(0, -1);
        this.input.setAttribute('placeholder', current);
        await wait(typingSpeed * 0.75);
      }
    };

    // Initial delay before first delete
    await wait(2000);

    let index = 0;
    while (true) {
      const next = placeholders[index = (index + 1) % placeholders.length];
      await deleteText(next);
      await wait(400); // Delay after delete
      await typeText(next);
      await wait(3000); // Delay after type in
    }
  }
}

customElements.define('search-form', SearchForm);
